import { createAction } from '../../types/redux';

export const LOAD_CANDIDATES = 'candidates2021/LOAD_CANDIDATES';
export const SAVE_CANDIDATES = 'candidates2021/SAVE_CANDIDATES';

export const loadCandidates = () => createAction(LOAD_CANDIDATES);
export const saveCandidates = (res) => createAction(SAVE_CANDIDATES, res);
